module.exports = __webpack_public_path__ + "assets/img/hammer.a905d535.png";